export default __webpack_public_path__ + "static/media/arrow_left.e848772d.svg";